import { Box, Link as RooLink } from '@qga/roo-ui/components';
import { TRAVEL_REQUIREMENTS_URL } from 'config/constants';
import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { ImportantInfoAlert } from 'components/Alerts';
import { WideLink } from 'components/Typography';

export const TravelDocumentationReminder = () => (
  <Box mb={8}>
    <ImportantInfoAlert>
      <ImportantInfoAlert.Heading>Before you travel, please check the latest government requirements</ImportantInfoAlert.Heading>
      <ImportantInfoAlert.Body>
        Some Australian states and territories have introduced new measures, including additional health and safety protocols, in response
        to Coronavirus.
      </ImportantInfoAlert.Body>
      <WideLink
        variant=""
        mt={2}
        color="emperor"
        underline={true}
        as={RooLink}
        href={TRAVEL_REQUIREMENTS_URL}
        onClick={tracking.viewTravelRequirementsLinkSelected}
        target="_blank"
      >
        View travel requirements
      </WideLink>
    </ImportantInfoAlert>
  </Box>
);
